export const SET_FIELD_TEXT = 'SET_FIELD_TEXT'
export const SET_ACTIVATE_LOADING_SPINNER = 'SET_ACTIVATE_LOADING_SPINNER'
export const UPDATE_ACCOUNT_ACTIVATION = 'UPDATE_ACCOUNT_ACTIVATION'
export const UPDATE_ACCOUNT_ACTIVATION_SUCCESS = 'UPDATE_ACCOUNT_ACTIVATION_SUCCESS'
export const UPDATE_ACCOUNT_ACTIVATION_FAILED = 'UPDATE_ACCOUNT_ACTIVATION_FAILED'
